/* eslint-disable react/prop-types */
import { useNavigate } from "react-router-dom";
import { createExcerpt } from "../../../../utils/utils";
import "./ProjectCard.css";
import { CustomButton } from "../../../../components";

export const ProjectCard = ({ project }) => {
    const navigate = useNavigate();
    return (
        <div className="project-card">
            <div className="project-image">
                <img
                    src={project.featured_image}
                    alt={project.title}
                    className="img"
                />
            </div>
            <div className="content">
                <div className="">
                    <h2>{project.project_title}</h2>
                    <p>{createExcerpt(project.project_description)}</p>
                </div>
                <CustomButton
                    onClick={() =>
                        navigate(`${project.id}`, {
                            state: { project: project },
                        })
                    }
                    content={"Read More"}
                    direction={"right"}
                    borderBottom
                />
            </div>
        </div>
    );
};
